import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import JsonTextarea from './JsonTextarea'

function OverridesEditor ({ overrides, seriesOverrides, layout, onChange }) {
  const handleChartOverridesChange = useCallback((value) => {
    onChange({ overrides: value })
  }, [onChange])

  const handleSeriesOverridesChange = useCallback((value) => {
    onChange({ seriesOverrides: value })
  }, [onChange])

  const showSeriesOverrides = layout !== 'axis'

  return (
    <div>
      <h4 style={{ margin: '0 0 12px 0' }}>Advanced Overrides</h4>
      <Grid container spacing={2}>
        <Grid item xs={12} md={showSeriesOverrides ? 6 : 12}>
          <JsonTextarea
            label='Chart Overrides'
            helperText='Top-level ECharts options merged into the chart config. Overrides take precedence over all other config fields.'
            value={overrides}
            onChange={handleChartOverridesChange}
          />
        </Grid>
        {showSeriesOverrides && (
          <Grid item xs={12} md={6}>
            <JsonTextarea
              label='Series Overrides'
              helperText='ECharts series options (label, itemStyle, emphasis, etc.) merged into the series config'
              value={seriesOverrides}
              onChange={handleSeriesOverridesChange}
            />
          </Grid>
        )}
      </Grid>
    </div>
  )
}

OverridesEditor.propTypes = {
  overrides: PropTypes.object,
  seriesOverrides: PropTypes.object,
  layout: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

export default OverridesEditor
